import type { EntitlementDecision } from '@tabbio/types';
import { getUpgradeReasonKey } from './upgrade-allowance-copy';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * The second line of the chat's subscription card when it is not a credit
 * banner: why this action stopped (a used daily image, files, searches or
 * edits, automations on Pro), else the generic upgrade line.
 */
export function subscriptionBlockedDescription(decision: Partial<EntitlementDecision> | undefined, t: Translate): string {
  const reason = getUpgradeReasonKey(
    decision?.reasonCode
      ? {
          placement: 'chat_limit',
          entryPoint: 'chat.subscription_blocked_card',
          planSet: decision.recommendedPlanSet ?? 'individual',
          recommendedTier: decision.recommendedTier ?? 'plus',
          reason: decision.reasonCode,
          actionKey: decision.actionKey,
          featureKey: decision.featureKey,
        }
      : null,
  );
  return reason
    ? t(`upgrade.context.reason.${reason}`, { plan: decision?.recommendedTier === 'pro' ? 'Pro' : 'Plus' })
    : t('chat.subscriptionBlocked.defaultMessage');
}
